import axios from "axios";
import { REACT_APP_API } from "../environment";

export const getTokenFromStorage = () => {
  return sessionStorage.getItem("token");
};
export const getAwsTokenFromStorage = () => {
  return sessionStorage.getItem("aws_token");
};
const token = getTokenFromStorage();
const aws_token = getAwsTokenFromStorage();

let headers = {
  "Content-Type": "application/json",
  "Authorization": token,
};

export const getUserPreferences = (email) => {
    headers['email'] = email;
    return axios.get(`${REACT_APP_API}/user_preferences`, { headers: headers });
}

export const getUserIdFromPreference = () => {
  const preference = sessionStorage.getItem("preference");
  if (preference) {
    const preferenceObj = JSON.parse(preference);
    return preferenceObj.id;
  }
  return null;
};

export const updateUserPreferences = (body) => {
    headers['id'] = body['id'];
    return axios.post(`${REACT_APP_API}/update_user_preference`, body, { headers: headers });
}


export const getNotificationData = (id) => {
  headers['id'] = id;
  return axios.get(`${REACT_APP_API}/fetch_notifications`, { headers: headers });
}

export const fetchAwsEvents = (email, event_type, options = {}) => {
  headers["email"] = email;
  headers["aws_token"] = aws_token;
  headers["event_type"] = event_type;

  const params = {};
  if (options.limit != null) params.limit = options.limit;
  if (options.cursor != null) params.cursor = options.cursor;

  return axios.get(`${REACT_APP_API}/awsEventsFetchData`, {
    headers,
    params: Object.keys(params).length ? params : undefined,
  });
};

export const updateNotification = async (body) => {
  try {
      headers['id'] = body['id'];
      const response = await axios.post(`${REACT_APP_API}/update_notifications`, body, { headers: headers });
      
      // Return only the response data, not the entire axios response object
      return response.data;
  } catch (error) {
      console.error("Error updating notification:", error);
      throw error;
  }
};

export const unsubscribeSubscriptions = (body) => {
  headers['id'] = body['id'];
  return axios.post(`${REACT_APP_API}/unsubscribe`, body, { headers: headers });
}

export const acknowledgeAwsEvent = ({
  releaseId, comment, username,
}) => {
  headers['username'] = username;
  return axios.post(
    `${REACT_APP_API}/aws/acknowledge`,
    { release_id: releaseId, comment },
    { headers: headers }
  );
}

